export type MonthlySeries = { month: string; inPerson?: number; online?: number; returning?: number; new?: number; value?: number }

export const prescriptionsOverTime: MonthlySeries[] = [
  { month: "July", inPerson: 286, online: 120 },
  { month: "Aug", inPerson: 405, online: 160 },
  { month: "Sept", inPerson: 337, online: 140 },
  { month: "Oct", inPerson: 309, online: 150 },
  { month: "Nov", inPerson: 314, online: 170 },
  { month: "Dec", inPerson: 250, online: 180 },
]

export const refillsOverTime: MonthlySeries[] = prescriptionsOverTime.map((d) => ({ month: d.month, value: d.inPerson || 0 }))

export const customersOverTime: MonthlySeries[] = prescriptionsOverTime.map((d) => ({ month: d.month, returning: d.inPerson || 0, new: d.online || 0 }))

export const valueOverTime: MonthlySeries[] = prescriptionsOverTime.map((d) => ({ month: d.month, value: (d.inPerson || 0) * 0.5 + (d.online || 0) * 0.4 }))

export const kpis = {
  filledPrescriptions: { total: 1589, deltaPct: 12.43 },
  refills: { total: 2825, deltaPct: 12.43 },
  returningCustomerRate: { pct: 39.71, deltaPct: 32.43 },
  newPatients: { total: 245, deltaPct: 12.43 },
  avgPrescriptionValue: { currency: "AED", value: 12.47, deltaPct: 12.43 },
}

export const categories = {
  filledBreakdown: [
    { label: "Pain Relief", value: 345.64, deltaPct: 17 },
    { label: "Antibiotics", value: 233.40, deltaPct: -29 },
    { label: "Supplements", value: 476.95, deltaPct: 43 },
  ],
  avgValueByMode: [
    { label: "Mail Order", value: 345.64, deltaPct: 17 },
    { label: "In-Store", value: 233.40, deltaPct: -29 },
    { label: "Delivery", value: 176.95, deltaPct: 43 },
  ],
  topPrescribed: [
    { label: "Levothyroxine", value: 345.64, deltaPct: 17 },
    { label: "Lisinopril", value: 233.40, deltaPct: -29 },
    { label: "Atorvastatin", value: 176.95, deltaPct: 43 },
  ],
  patientReportsType1: [
    { label: "Antidepressant Prescriptions", value: 950, deltaPct: 25 },
    { label: "Anxiolytic Prescriptions", value: 650, deltaPct: -20 },
    { label: "Sleep Aid Prescriptions", value: 400, deltaPct: 55 },
  ],
  patientReportsType2: [
    { label: "Nutritional Supplements", value: 780, deltaPct: 15 },
    { label: "Pain Relief Medications", value: 500, deltaPct: -30 },
    { label: "Chronic Disease Management", value: 900, deltaPct: 40 },
  ],
}